import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit"
export default class extends Controller {
  DEFAULT_TIMEOUT = 500;

  connect() {
  }

  disconnect() {
    this.stopTimer();
  }

  handleChange({ target, params: { timeout } }) {
    if (this.hasTimerStarted())
      this.resetTimer(target, timeout);
    else
      this.submitAfterTimer(target, timeout);
  }

  getParentForm(element) {
    return element.closest('form');
  }

  hasTimerStarted() {
    return this.timeout !== undefined;
  }

  submitAfterTimer(element, timeout) {
    let form = this.getParentForm(element);

    if (timeout !== undefined)
      this.timeout = setTimeout(form => this.submit(form), timeout, form);
    else
      this.timeout = setTimeout(form => this.submit(form), this.DEFAULT_TIMEOUT, form);
  }

  submit(form) {
    const data = new URLSearchParams(new FormData(form));
    const url = form.attributes?.action?.value;

    const headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded')
    const csrf = document.querySelector('[name="csrf-token"]')
    if (csrf) {
      headers.append('X-CSRF-Token', document.querySelector('[name="csrf-token"]').content)
    }

    fetch(url, {
      method: 'POST',
      headers: headers,
      body: data
    }).then(_ => { /* noop */ })
  }

  resetTimer(element, timeout) {
    this.stopTimer();
    this.submitAfterTimer(element, timeout);
  }

  stopTimer() {
    clearTimeout(this.timeout);
  }
}